
import React from 'react';
import styles from './_layout-selector-dialog.module.scss';
import { IPageLayout } from '../../../store/preferences/actions';
import { DialogProps } from '../DialogProps';
import {
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import { Button } from '@progress/kendo-react-buttons';
import { ComboBox, ComboBoxChangeEvent } from '@progress/kendo-react-dropdowns';
import { Label } from "@progress/kendo-react-labels";

export interface LayoutSelectorDialogProps extends DialogProps<IPageLayout> {
  pageLayouts: IPageLayout[];
  selectedLayout?: IPageLayout | null;
}

export default function LayoutSelectorDialog (props:  LayoutSelectorDialogProps) {
  const [selectedLayout, setSelectedLayout] = React.useState<IPageLayout | undefined>(props.selectedLayout ?? undefined); 
  return (
    <>
    <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
      Select a Layout
    </DialogTitle>
    <DialogContent className={styles.layoutSelectorDialogContainer}>
      <ComboBox
        label={'Page Layout'}
        data={props.pageLayouts}
        textField="name"
        suggest={true}
        clearButton={false}
        value={selectedLayout}
        style={{marginBottom: '10px'}}
        onChange={(event: ComboBoxChangeEvent) => {
          setSelectedLayout(event.value);
        }}
      />
      <div className='k-floating-label-container' style={{marginTop: '15px'}}>
        <Label className='k-label'>Description</Label>
        <div className={styles.description}>
          {selectedLayout?.description}
        </div>
      </div>
    </DialogContent>
    <DialogActions>
      <Button autoFocus onClick={props.closeDialog} themeColor='info' fillMode="outline">
        Cancel
      </Button>
      <Button
        onClick={() => {
          selectedLayout && props.accept && props.accept(selectedLayout);
        }}
        themeColor="success"
        fillMode="outline"
        disabled={!selectedLayout}
      >
        Select
      </Button>
    </DialogActions>
  </>
);
}
